exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slotWarningsTable[data-v-1eabcdd6] tbody tr:hover{background-color:rgba(171,59,123,.10588235294117647)!important}.v-menu__content[data-v-1eabcdd6]{max-height:90%!important;overflow:hidden}.v-data-table[data-v-1eabcdd6] .sticky-header{position:sticky;top:0;z-index:1}", ""]);

// exports
